export const STATS_FETCHING_DELAY = 5000;
export const RETRY_LIMIT = 5;
